module.exports = __webpack_public_path__ + "img/games-icon.14e1b354.svg";